const SHOWTIMES_DATA = [
    {
        slug: 'MI',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'MIB',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'DH',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'TS4',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'AH',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'Abominable',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'glass',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'IO',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'LK',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
    {
        slug: 'SO',
        english3d: ['9:25 AM','11:30 AM','1:10 PM'],
        hindi3d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        english2d: ['9:25 AM','11:30 AM','1:10 PM', '3:35 PM'],     
        imax: ['9:25 AM','11:30 AM']    
    },
]; 
export default SHOWTIMES_DATA;